@if (examRecap) {
	<div class="row">
		<div class="col-sm-3 col-md-3 col-lg-3">
			<h4 class="section-title bg-default mrgn-btm">Rx(s)</h4>
			@if (examRecap.eyeglassPrescriptions.length <= 0 && examRecap.contactLensPrescriptions.length <= 0 && examRecap.contactLensTrials.length <= 0) {
				<p class="margin-bottom-lg margin-left-sm">No data to display</p>
			} @else {
				@for (eyeglass of examRecap.eyeglassPrescriptions; track eyeglass) {
					<div class="margin-left-sm" [attr.data-test-id]="'rapidReviewEyeglassRx' + eyeglass.eyeglassPrescriptionId">
						<h4 class="panel-title mrgn-btm">
							<strong>Eyeglass Rx ({{ eyeglass.usedFor ?? 'Unspecified' }})</strong>
						</h4>
						<div>
							<strong class="rapid-review-od">OD:</strong> {{ PrescriptionUtil.formatPrescriptionValues(eyeglass.od.sphere, eyeglass.od.cylinder, eyeglass.od.axis, eyeglass.od.nearAdd) }}
						</div>
						<div class="margin-bottom-md">
							<strong class="rapid-review-os">OS:</strong> {{ PrescriptionUtil.formatPrescriptionValues(eyeglass.os.sphere, eyeglass.os.cylinder, eyeglass.os.axis, eyeglass.os.nearAdd) }}
						</div>
						@if (isExpired(eyeglass.status)) {
							<div class="label label-danger margin-right-md">EXPIRED</div><strong class="text-danger">{{ eyeglass.expirationDate | date: dateFormat }}</strong>
						} @else if (isPending(eyeglass.status)) {
							<div class="label label-warning">PENDING</div>
						} @else {
							<div class="label rapid-review-label-success margin-right-md">ACTIVE</div> <strong>Expires:</strong> {{ eyeglass.expirationDate | date: dateFormat }}
						}
					</div>
					@if (!$last) {
						<hr class="rapid-review-separator">
					}
				}
				@if (examRecap.eyeglassPrescriptions.length > 0 && examRecap.contactLensPrescriptions.length > 0) {
					<hr class="rapid-review-separator">
				}
				@for (contactLens of examRecap.contactLensPrescriptions; track contactLens) {
					<div class="margin-left-sm" [attr.data-test-id]="'rapidReviewClRx' + contactLens.contactLensPrescriptionId">
						<h4 class="panel-title mrgn-btm">
							<strong>Contact Lens Rx</strong>
						</h4>
						<div>
							<strong class="rapid-review-od">OD:</strong> {{ PrescriptionUtil.formatPrescriptionValues(contactLens.od?.sphere, contactLens.od?.cylinder, contactLens.od?.axis, null) }}
						</div>
						<div>
							<strong class="rapid-review-os">OS:</strong> {{ PrescriptionUtil.formatPrescriptionValues(contactLens.os?.sphere, contactLens.os?.cylinder, contactLens.os?.axis, null) }}
						</div>
						<div>
							<strong class="rapid-review-od">OD:</strong> {{ contactLens.od?.productName }}
						</div>
						<div class="margin-bottom-md">
							<strong class="rapid-review-os">OS:</strong> {{ contactLens.os?.productName }}
						</div>
						@if (isExpired(contactLens.status)) {
							<div class="label label-danger margin-right-md">EXPIRED</div><strong class="text-danger">{{ contactLens.expirationDate | date: dateFormat }}</strong>
						} @else if (isPending(contactLens.status)) {
							<div class="label label-warning">PENDING</div>
						} @else {
							<div class="label rapid-review-label-success margin-right-md">ACTIVE</div> <strong>Expires:</strong> {{ contactLens.expirationDate | date: dateFormat }}
						}
					</div>
					@if (!$last) {
						<hr class="rapid-review-separator">
					}
				}
				@if ((examRecap.eyeglassPrescriptions.length > 0 || examRecap.contactLensPrescriptions.length > 0) && examRecap.contactLensTrials.length > 0) {
					<hr class="rapid-review-separator">
				}
				@for (trial of examRecap.contactLensTrials; track trial) {
					<div class="margin-left-sm" [attr.data-test-id]="'rapidReviewTrialRx' + trial.contactLensTrialId">
						<h4 class="panel-title mrgn-btm">
							<strong>Contact Len Trial</strong>
						</h4>
						<div>
							<strong class="rapid-review-od">OD:</strong> {{ PrescriptionUtil.formatPrescriptionValues(trial.od?.sphere, trial.od?.cylinder, trial.od?.axis, null) }}
						</div>
						<div>
							<strong class="rapid-review-os">OS:</strong> {{ PrescriptionUtil.formatPrescriptionValues(trial.os?.sphere, trial.os?.cylinder, trial.os?.axis, null) }}
						</div>
						<div>
							<strong class="rapid-review-od">OD:</strong> {{ trial.od?.productName }}
						</div>
						<div class="margin-bottom-lg">
							<strong class="rapid-review-os">OS:</strong> {{ trial.os?.productName }}
						</div>
					</div>
					@if (!$last) {
						<hr class="rapid-review-separator">
					}
				}
			}
		</div>
		<div class="col-sm-3 col-md-3 col-lg-3">
			<h4 class="section-title bg-default mrgn-btm">Entrance Testing</h4>
			<div class="row margin-left-sm">
				@for (test of examRecap.entranceTests; track test) {
					<div class="margin-bottom-lg">
						<pms-rapid-review-test [test]="test"></pms-rapid-review-test>
					</div>
					@if (!$last) {
						<hr class="rapid-review-separator">
					}
				} @empty {
					<p class="margin-bottom-lg">No data to display</p>
				}
			</div>
		</div>
		<div class="col-sm-3 col-md-3 col-lg-3">
			<h4 class="section-title bg-default mrgn-btm">Refractive / Specialty Tests</h4>
			<div class="row margin-left-sm">
				@for (test of examRecap.specialtyTests; track test) {
					<div class="margin-bottom-lg">
						<pms-rapid-review-test [test]="test"></pms-rapid-review-test>
					</div>
					@if (!$last) {
						<hr class="rapid-review-separator">
					}
				} @empty {
					<p class="margin-bottom-lg">No data to display</p>
				}
			</div>
		</div>
		<div class="col-sm-3 col-md-3 col-lg-3">
			<h4 class="section-title bg-default mrgn-btm">Medical Testing</h4>
			<div class="row margin-left-sm">
				@for (test of examRecap.medicalTests; track test) {
					<div class="margin-bottom-lg">
						<pms-rapid-review-test [test]="test"></pms-rapid-review-test>
					</div>
					@if (!$last) {
						<hr class="rapid-review-separator">
					}
				} @empty {
					<p class="margin-bottom-lg">No data to display</p>
				}
			</div>
		</div>
	</div>
}
